enum ActionType {
    REQUEST_SELF_MONITORING_ENGINE_EVENTS = '[SELF MONITORING ENGINE EVENTS] REQUEST DATA',
    RECEIVED_SELF_MONITORING_ENGINE_EVENTS = '[SELF MONITORING ENGINE EVENTS] RECEIVE DATA',
}

export default ActionType
